import React from "react";
import { NavLink } from "react-router-dom";
import { routes } from "routes";

import { Button } from "components/Button";
import { useAuthContext } from "context/AuthContext";

export const Nav = () => {
  const { logout, isLoading } = useAuthContext();

  return (
    <header className="border-bottom z-50 flex w-full flex-wrap border-b-2 bg-white py-2 text-sm sm:flex-nowrap sm:justify-start">
      <nav className="container mx-auto w-full px-4 sm:flex sm:items-center sm:justify-between" aria-label="Global">
        <span className="flex-none text-xl font-semibold">iTint Admin</span>
        <div className="mt-5 flex flex-row flex-wrap items-center gap-5 sm:mt-0 sm:justify-end sm:ps-5">
          {routes.map((route) => {
            return (
              !!route.navLabel && (
                <NavLink
                  key={route.route}
                  className={({ isActive }) =>
                    isActive ? "border-b-2 border-b-indigo-500 py-2 font-medium" : "border-b-2 border-b-transparent py-2 font-medium text-neutral-600 hover:border-b-neutral-400 hover:text-neutral-400"
                  }
                  to={route.route}
                >
                  {route.navLabel}
                </NavLink>
              )
            );
          })}
          <Button color="secondary" disabled={isLoading} size="sm" onClick={logout}>
            Logout
          </Button>
        </div>
      </nav>
    </header>
  );
};
